/* eslint-disable
    no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
angular.module('unergie.main')
.factory('SocketFactory', (socketFactory, $location, BoFeaturesService) => {
    const host = $location.host() === 'local.unergie.com' ? `:${$location.port()}/` : '/'

    let factory

    const rooms = {}
    const events = []

    const reconnect = () => _.forEach(rooms, (v, r) => getSocket().emit('join', r))


    const getSocket = function () {
        if (!factory) {
            factory = socketFactory({ ioSocket: io.connect(host, { path: '/ws/socket.io', reconnect: true, transports: ['websocket'], upgrade: false }) })
            factory.on('reconnect', () => reconnect())
        }
        return factory
    }

    const leave = function (room) {
        if (BoFeaturesService.isFeatureOn('webSockets')) {
            getSocket().emit('leave', room)
            return delete rooms[room]
        }
    }

    const join = function (room, scope) {
        if (BoFeaturesService.isFeatureOn('webSockets') && !rooms[room]) {
            getSocket().emit('join', room)
            rooms[room] = 1
            return scope.$on('$destroy', () => leave(room))
        }
    }

    const register = function (event, callback) {
        if (BoFeaturesService.isFeatureOn('webSockets') && !events.includes(event)) {
            events.push(event)
            return getSocket().on(event, (e) => {
                e.source = 'ws'
                return callback(e)
            })
        }
    }

    const send = function (event, paylaod) {
        if (BoFeaturesService.isFeatureOn('webSockets')) {
            return getSocket().emit(event, paylaod)
        }
    }

    const disconnect = function () {
        if (BoFeaturesService.isFeatureOn('webSockets')) {
            getSocket().disconnect()
            return (factory = undefined)
        }
    }

    return {
        join,
        leave,
        register,
        send,
        disconnect,
    }
})
